/**
 * Notificación push + alerta en pantalla para tickets de servicio.
 * Muestra tanto notificación del sistema como toast dentro de la aplicación.
 */
import { useCallback } from 'react';
import Swal from 'sweetalert2';
import { useRealtimeOn } from '../context/RealtimeSocketContext';
import { notifyDesktopViaServiceWorkerOrFallback } from '../utils/webPush';

export default function ServiceTicketDesktopNotify() {
  const onUpdate = useCallback((payload) => {
    const { ticket_id, action } = payload || {};
    if (ticket_id == null) return;

    let title = 'Ticket de servicio';
    let body = `Cambios en el ticket #${ticket_id}.`;

    if (action === 'created') {
      title = 'Nuevo ticket de servicio';
      body = `Se creó el ticket #${ticket_id}.`;
    } else if (action === 'updated') {
      title = 'Ticket de servicio actualizado';
      body = `Se actualizó el ticket #${ticket_id}.`;
    }

    // 1. Notificación push del sistema
    notifyDesktopViaServiceWorkerOrFallback(title, body, {
      tag: `hs-svc-ticket-${ticket_id}`,
      renotify: true,
      url: '/service-tickets',
      inPageToastWhenVisible: false,
    }).catch(() => {});

    // 2. Alerta en pantalla
    Swal.fire({
      icon: action === 'created' ? 'success' : 'info',
      title: title,
      text: body,
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 6000,
      timerProgressBar: true,
      showCloseButton: true,
      customClass: {
        popup: 'swal-ticket-notification'
      }
    });
  }, []);

  useRealtimeOn('service_ticket_updated', onUpdate);

  return null;
}
